import gql from 'graphql-tag';

import answerFields from 'src/graphql/fragments/answerFields';

export default gql`
  mutation deleteAnswerAudio(
    $answerId: ID
  ) {
    deleteAnswerAudio(
      answerId: $answerId
    ) {
      ...answerFields
    }
  }
  ${answerFields}
`;
